import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { RegisterAssemblyDisapprovalByOrderInput } from './RegisterAssemblyDisapprovalByOrderInput';
import { RegisterAssemblyDisapprovalByOrderOutput } from './RegisterAssemblyDisapprovalByOrderOutput';

export class RegisterAssemblyDisapprovalByOrderService extends HttpServiceBase {

  handle = (input: RegisterAssemblyDisapprovalByOrderInput): Promise<Result<RegisterAssemblyDisapprovalByOrderOutput> | null> => {
    const promise = this.http.post<Result<RegisterAssemblyDisapprovalByOrderOutput>, RegisterAssemblyDisapprovalByOrderInput>(
      `${this.baseUrlSislogApi}/v2/order/${input.orderId}/assembly-disapproval`,
      input
    );
    return promise;
  }

}